/* eslint-disable */
import { AUTH_PRESENCE_CHANGED, AUTH_PRESENCE_CHANGED_COMPLETE, AUTH_PRESENCE_CHANGED_ERROR, AUTH_PRESENCE_CHANGED_NEXT } from '../Auth.types';

/**
 * Watch for auth presence changes and fire the appropriate actions
 * @param {CallbackFunction} callback A `callback` to be invoked upon calls from the observable callback
 * @returns {ActionCreator<FromObservableCallback<AuthEntity | null, Error, {}, AUTH_PRESENCE_CHANGED, AUTH_PRESENCE_CHANGED_COMPLETE, AUTH_PRESENCE_CHANGED_ERROR, AUTH_PRESENCE_CHANGED_NEXT>>} A Function to stop listening to the Observable
 */
const authOnAuthPresenceChanged = (callback) => ({ authService, fromObservableCallback }) => {
  return fromObservableCallback(authService.onAuthPresenceChanged, callback, {}, [
    AUTH_PRESENCE_CHANGED,
    AUTH_PRESENCE_CHANGED_COMPLETE,
    AUTH_PRESENCE_CHANGED_ERROR,
    AUTH_PRESENCE_CHANGED_NEXT,
  ]);
};

export default authOnAuthPresenceChanged;
